var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachment = function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M10.143 1.5v4.444c0 1.048 0 1.572.335 1.897.335.326.873.326 1.95.326H17M10.34 1.5H5.57c-2.155 0-3.232 0-3.901.651C1 2.802 1 3.85 1 5.944v11.112c0 2.095 0 3.142.67 3.793s1.746.651 3.901.651h6.858c2.155 0 3.232 0 3.901-.651.67-.651.67-1.698.67-3.793v-9.08c0-.454 0-.682-.087-.885s-.251-.365-.583-.687l-4.375-4.253c-.331-.322-.496-.482-.705-.567-.21-.084-.444-.084-.91-.084Z"
  })));
};
export default SvgAttachment;